<template>
  <app-btn @click="open">
    <slot></slot>
  </app-btn>
</template>

<script setup lang="ts">
import { useFileDialog } from '@vueuse/core'
import appBtn from './AppBtn.vue'

const emit = defineEmits(['loaded'])
const { open, onChange } = useFileDialog({ accept: 'image/*' })

onChange((fileList) => {
  if (!fileList?.length) return
  const file = fileList[0]
  if (!file) return
  const blobUrl = URL.createObjectURL(file)
  emit('loaded', { blobUrl, file })
})
</script>
